import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '@env/environment';
import { EMPTY, Observable } from 'rxjs';
import { Comments, DataListOfTaskStages } from '../modal/tasks';
import { FormGroup } from '@angular/forms';
import { SharedService } from 'app/shared/services/shared.service';
@Injectable({
  providedIn: 'root'
})

export class TasksService {

  listOfGiven: any[] = [
    { name: 'GAP', id: 2 },
    { name: 'Stage 1', id: 3 },
    { name: 'Stage 2', id: 4 },
    { name: 'اصدار', id: 5 },
  ];
  listOfQualifying: any[] = [
    { name: 'انشاء و تطبيق النظام', id: 6 },
    { name: 'تسليم و  تطبيق النظام', id: 7 },
    { name: 'Awareness 1', id: 8 },
    { name: 'Awareness 2', id: 9 },
    { name: 'Awareness 3 ', id: 10 },
    { name: 'مراجعة ', id: 11 },
    { name: 'internal audit', id: 12 },
    { name: 'مراجعه التطبيق', id: 13 },
  ];

  listOfType: any[] = [
    { name: 'مهمه', id: 0 },
    { name: 'المنح', id: 1 },
    { name: 'التأهيل', id: 2 },
  ];

  constructor(
    private http: HttpClient,
    private _SharedService: SharedService
  ) { }


  getListOfType(dep_id:any){
    return this.http.get(`${env.domain}TaskType/GetTasksTypes/${dep_id}`);
  }
  getListOfTypeTree(dep_id:any){
    return this.http.get(`${env.domain}TaskType/GetTasksTypesTree/${dep_id}`);
  }
  getTaskTypeById(id: number): Observable<any> {
    return this.http.get<any>(`${env.domain}TaskType/GetById/${id}`);
  }
  getListOfPriorities(){
    return this.http.get(`${env.domain}Tasks/ListOfPriorities`)
  }

  getGiven(typeOfOperation: number) {
    return this.listOfGiven.find(item => item.id == typeOfOperation)
  }

  getQualifying(typeOfOperation: number) {
    return this.listOfQualifying.find(item => item.id == typeOfOperation)
  }

  GetClientCertificateDataById(afaqClientId: number): Observable<any> {
    return this.http.get(`${env.domain}Clients/GetClientAfaqById/${afaqClientId}`)
  }

  // GetClientCertificateDataById(afaqClientId: number): Observable<any> {
  //   return this.http.get(`${env.domainAfaq}ClientCertificates/GetClientCertificateDataById/${afaqClientId}`)
  // }

  getAllTasks(query: any): Observable<any> {
    const value: any = {};
    // debugger;
    // for (const key in query) {
    //   if (query[key]) {
    //     value[key] = query[key];  // for no send null value
    //   }
    // }
    // return this.http.get(`${env.domain}Tasks/GetAllTasks`, { params: value })
    // -------- Eng Ahmed Abdelhameed Ali --------
    return this.http.post(`${env.domain}Tasks/GetAllTasks`, query)
  }

  addTask(body: any): Observable<any> {
    let value = {};
    for (const key in body) {
      if (body[key]) {
        value[key] = body[key];
      }
    }
    return this.http.post(`${env.domain}Tasks/AddTask`, this._SharedService.formateFormData(body))
  }
  AddTaskApproval(body: any): Observable<any> {
    return this.http.post(`${env.domain}Tasks/AddTaskApproval/${body['id']}`, body)
  }
  EditTask(body: any): Observable<any> {
    return this.http.put(`${env.domain}Tasks/EditTask/${body['Id']}`, this._SharedService.formateFormData(body))
  }
  getTaskById(TaskId: number): Observable<any> {
    return this.http.get(`${env.domain}Tasks/GetTaskById/${TaskId}`)
  }
  ChangeActiveOrNotTask(TaskId: number): Observable<any> {
    return this.http.put(`${env.domain}Tasks/ChangeActiveOrNotTask/${TaskId}`, {})
  }
  RemoveTask(TaskId: number): Observable<any> {
    return this.http.delete(`${env.domain}Tasks/RemoveTask/${TaskId}`)
  }
  ListOfPriorities(): Observable<any> {
    return this.http.get(`${env.domain}Tasks/ListOfPriorities`)
  }
  ListOfTasks(TaskId: number): Observable<any> {
    return this.http.get(`${env.domain}Tasks/ListOfTasks/${TaskId}`)
  }
  ListOfTaskStages(): Observable<any> {
    return this.http.get(`${env.domain}Tasks/ListOfTaskStages`)
  }
  ListOfEmployees(query: any): Observable<any> {
    return this.http.get(`${env.domain}Employees/ListOfEmployees`, { params: query })
  }
  EditTaskProgressing(body: any): Observable<any> {
    return this.http.put(`${env.domain}Tasks/EditTaskProgressing`, body)
  }
  GetAllTaskComments(value: any): Observable<any> {
    return this.http.get(`${env.domain}Tasks/GetAllTaskComments`, { params: this._SharedService.checkQuery(value) })
  }
  AddTaskComment(body: any) {
    return this.http.post(`${env.domain}Tasks/AddTaskComment`, this._SharedService.formateFormData(body))
  }
  AddMentionedEmployees(form: any = {}) {
    return this.http.post(`${env.domain}Tasks/AddMentionedEmployees`, form)
  }
  DeleteFileOrMoreOfTasks(listOfId: any[] = []): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(listOfId),
    };
    return this.http.delete<any>(`${env.domain}Tasks/DeleteFileOrMoreOfTask`, options)
  }

  GetAllTasksByCompanyOrDepartmentId(): Observable<any> {
    return this.http.get(`${env.domain}Tasks/GetAllTasksByCompanyOrDepartmentId`)
  }
  GetAllTasksPerEmp_Id(body: any): Observable<any> {
    return this.http.post(`${env.domain}Tasks/AllEmployeeTasks`,body)
  }
  GetDepartmentIdByProjectId(projectID: number): Observable<any> {
    return this.http.get(`${env.domain}Projects/GetDepartmentIdByProjectId/${projectID}`)
  }
  RemoveTaskComment(id: number): Observable<any> {
    return this.http.delete<any>(`${env.domain}Tasks/RemoveTaskComment/${id}`)
  }




}

